const Cash: React.FC<React.SVGProps<SVGSVGElement>> = props => {
  return (
    <svg
      width="20"
      height="20"
      fill="none"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      className={props.className ?? ''}>
      <path
        fill="currentColor"
        d="M2.499 2.5c-0.46 0 -0.833 0.374 -0.833 0.833v8.334c0 0.46 0.373 0.833 0.833 0.833h15c0.46 0 0.833 -0.374 0.833 -0.833V3.333c0 -0.46 -0.374 -0.833 -0.833 -0.833zm1.593 1.667h11.813a1.247 1.247 0 0 0 0.761 0.76v5.146a1.247 1.247 0 0 0 -0.761 0.76H4.093a1.247 1.247 0 0 0 -0.76 -0.76V4.927a1.253 1.253 0 0 0 0.76 -0.76M10 5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0 -5m-4.167 1.667a0.833 0.833 0 1 0 0 1.666 0.833 0.833 0 0 0 0 -1.666m8.334 0a0.833 0.833 0 1 0 -0.001 1.666 0.833 0.833 0 0 0 0 -1.666m-10.842 7.5L16.024 17.474c0.446 0.116 0.9 -0.152 1.016 -0.597l0.706 -2.711h-1.722l-0.197 0.751c-0.374 0.033 -0.712 0.232 -0.923 0.542l-4.964 -1.292z"
      />
    </svg>
  );
};

export default Cash;
